:host {
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  padding-bottom: var(--ux-steps-item-padding-bottom, 32px);

  &::before {
    background: linear-gradient(to right, $color-white 0, $color-green 100%);
    content: "";
    height: 2px;
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: $z-index-steps-items-before;

    @media only screen and (width >=768px) {
      height: 3px;
    }
  }
}

:host([generated]) {
  padding-bottom: 0;
}

.ux-steps {

  &__outer-line {
    height: 2px;
    width: 100%;

    @media only screen and (width >=768px) {
      height: 3px;
    }
  }

  &__outer-line--right {
    background: linear-gradient(to right, $color-gray-inactive 0, $color-white 100%);
  }

  &__outer-line--left {
    background: linear-gradient(to right, $color-white 0, $color-green 100%);
  }

  &__indicators {
    display: flex;
  }
}


ux-steps-item:last-of-type,
::slotted(ux-steps-item:last-of-type) {
  margin-right: 0;
}